/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Pim.Api | rt-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner } from './AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner';
import {
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON,
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSONTyped,
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON,
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSONTyped,
} from './AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner';

/**
 * An import, as sent in realtime notifications.
 * @export
 * @interface ImportNotificationPayloadImportsInner
 */
export interface ImportNotificationPayloadImportsInner {
    /**
     * Id of the company the import belongs to.
     * @type {string}
     * @memberof ImportNotificationPayloadImportsInner
     */
    companyId: string;
    /**
     * Kind of import.
     * @type {ImportNotificationPayloadImportsInnerTypeEnum}
     * @memberof ImportNotificationPayloadImportsInner
     */
    type: ImportNotificationPayloadImportsInnerTypeEnum;
    /**
     * Current status of the import.
     * @type {ImportNotificationPayloadImportsInnerStatusEnum}
     * @memberof ImportNotificationPayloadImportsInner
     */
    status: ImportNotificationPayloadImportsInnerStatusEnum;
    /**
     * Number of products processed so far, successfully or not.
     * @type {number}
     * @memberof ImportNotificationPayloadImportsInner
     */
    processedProductsNumber: number;
    /**
     * Number of products imported successfully so far.
     * @type {number}
     * @memberof ImportNotificationPayloadImportsInner
     */
    successfullyProcessedProductsNumber: number;
    /**
     * Number of products that failed to import so far.
     * @type {number}
     * @memberof ImportNotificationPayloadImportsInner
     */
    failedProcessedProductsNumber: number;
    /**
     * Number of media assets imported so far.
     * @type {number}
     * @memberof ImportNotificationPayloadImportsInner
     */
    processedMediaNumber: number;
    /**
     * Number of products in the input of the import.
     * @type {number}
     * @memberof ImportNotificationPayloadImportsInner
     */
    inputProductsCount: number;
    /**
     * Id of the background job processing the import, if any.
     * @type {string}
     * @memberof ImportNotificationPayloadImportsInner
     */
    jobId?: string | null;
    /**
     * Companies that own the import, with the permissions each has on it.
     * @type {Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>}
     * @memberof ImportNotificationPayloadImportsInner
     */
    ownedByCompanies: Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>;
    /**
     * Groups that own the import, with the permissions each has on it.
     * @type {Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>}
     * @memberof ImportNotificationPayloadImportsInner
     */
    ownedByGroups: Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>;
    /**
     * Id of the resource.
     * @type {string}
     * @memberof ImportNotificationPayloadImportsInner
     */
    id: string;
    /**
     * Id of the user who created the resource.
     * @type {string}
     * @memberof ImportNotificationPayloadImportsInner
     */
    createdBy: string;
    /**
     * Id of the user who last updated the resource.
     * @type {string}
     * @memberof ImportNotificationPayloadImportsInner
     */
    updatedBy: string;
    /**
     * When the resource was created.
     * @type {Date}
     * @memberof ImportNotificationPayloadImportsInner
     */
    createdAt: Date;
    /**
     * When the resource was last updated.
     * @type {Date}
     * @memberof ImportNotificationPayloadImportsInner
     */
    updatedAt: Date;
    /**
     * The users and service accounts the resource is shared with, and their permissions on it.
     * @type {Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>}
     * @memberof ImportNotificationPayloadImportsInner
     */
    ownedByUsers: Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>;
    /**
     * The permissions of the current user on the resource.
     * @type {Array<ImportNotificationPayloadImportsInnerAgentPermissionsEnum>}
     * @memberof ImportNotificationPayloadImportsInner
     */
    agentPermissions?: Array<ImportNotificationPayloadImportsInnerAgentPermissionsEnum> | null;
}


/**
 * @export
 */
export const ImportNotificationPayloadImportsInnerTypeEnum = {
    As400: 'as400',
    PimCsv: 'pimCsv'
} as const;
export type ImportNotificationPayloadImportsInnerTypeEnum = typeof ImportNotificationPayloadImportsInnerTypeEnum[keyof typeof ImportNotificationPayloadImportsInnerTypeEnum];

/**
 * @export
 */
export const ImportNotificationPayloadImportsInnerStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Failed: 'failed',
    Canceled: 'canceled',
    Completed: 'completed'
} as const;
export type ImportNotificationPayloadImportsInnerStatusEnum = typeof ImportNotificationPayloadImportsInnerStatusEnum[keyof typeof ImportNotificationPayloadImportsInnerStatusEnum];

/**
 * @export
 */
export const ImportNotificationPayloadImportsInnerAgentPermissionsEnum = {
    List: 'list',
    Create: 'create',
    Update: 'update',
    Delete: 'delete',
    Share: 'share'
} as const;
export type ImportNotificationPayloadImportsInnerAgentPermissionsEnum = typeof ImportNotificationPayloadImportsInnerAgentPermissionsEnum[keyof typeof ImportNotificationPayloadImportsInnerAgentPermissionsEnum];


/**
 * Check if a given object implements the ImportNotificationPayloadImportsInner interface.
 */
export function instanceOfImportNotificationPayloadImportsInner(value: object): value is ImportNotificationPayloadImportsInner {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('processedProductsNumber' in value) || value['processedProductsNumber'] === undefined) return false;
    if (!('successfullyProcessedProductsNumber' in value) || value['successfullyProcessedProductsNumber'] === undefined) return false;
    if (!('failedProcessedProductsNumber' in value) || value['failedProcessedProductsNumber'] === undefined) return false;
    if (!('processedMediaNumber' in value) || value['processedMediaNumber'] === undefined) return false;
    if (!('inputProductsCount' in value) || value['inputProductsCount'] === undefined) return false;
    if (!('ownedByCompanies' in value) || value['ownedByCompanies'] === undefined) return false;
    if (!('ownedByGroups' in value) || value['ownedByGroups'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('ownedByUsers' in value) || value['ownedByUsers'] === undefined) return false;
    return true;
}

export function ImportNotificationPayloadImportsInnerFromJSON(json: any): ImportNotificationPayloadImportsInner {
    return ImportNotificationPayloadImportsInnerFromJSONTyped(json, false);
}

export function ImportNotificationPayloadImportsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportNotificationPayloadImportsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'type': json['type'],
        'status': json['status'],
        'processedProductsNumber': json['processedProductsNumber'],
        'successfullyProcessedProductsNumber': json['successfullyProcessedProductsNumber'],
        'failedProcessedProductsNumber': json['failedProcessedProductsNumber'],
        'processedMediaNumber': json['processedMediaNumber'],
        'inputProductsCount': json['inputProductsCount'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'ownedByCompanies': ((json['ownedByCompanies'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON)),
        'ownedByGroups': ((json['ownedByGroups'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON)),
        'id': json['id'],
        'createdBy': json['createdBy'],
        'updatedBy': json['updatedBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'ownedByUsers': ((json['ownedByUsers'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON)),
        'agentPermissions': json['agentPermissions'] == null ? undefined : json['agentPermissions'],
    };
}

export function ImportNotificationPayloadImportsInnerToJSON(json: any): ImportNotificationPayloadImportsInner {
    return ImportNotificationPayloadImportsInnerToJSONTyped(json, false);
}

export function ImportNotificationPayloadImportsInnerToJSONTyped(value?: ImportNotificationPayloadImportsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'type': value['type'],
        'status': value['status'],
        'processedProductsNumber': value['processedProductsNumber'],
        'successfullyProcessedProductsNumber': value['successfullyProcessedProductsNumber'],
        'failedProcessedProductsNumber': value['failedProcessedProductsNumber'],
        'processedMediaNumber': value['processedMediaNumber'],
        'inputProductsCount': value['inputProductsCount'],
        'jobId': value['jobId'],
        'ownedByCompanies': ((value['ownedByCompanies'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON)),
        'ownedByGroups': ((value['ownedByGroups'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON)),
        'id': value['id'],
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'ownedByUsers': ((value['ownedByUsers'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON)),
        'agentPermissions': value['agentPermissions'],
    };
}

